export default __webpack_public_path__ + "static/media/ic-data-operator.850ef025.svg";